// extracted by mini-css-extract-plugin
module.exports = {"cw_filter__badge":"FilterBadgeComponent_cw_filter__badge__JW9lU","cw_filter__badge__icon":"FilterBadgeComponent_cw_filter__badge__icon__0R7hf"};